export default [] as any[]; // PASTE YOUR GOOGLE TAKEOUT REVIEWS ARRAY HERE
